import Cookies from 'js-cookie';

const HELENA_ROUTE_PERSONA = {
  'agenda-helena': 'member',
  'patients-helena': 'member',
  'medical-records-helena': 'doctor',
  new_medical_record_helena: 'doctor',
};

export function personaForHelenaRouteName(routeName) {
  if (!routeName) return 'member';
  return HELENA_ROUTE_PERSONA[routeName] || 'member';
}

export function isHelenaDashboardRoute(route) {
  const n = route?.name;
  return typeof n === 'string' && n.includes('helena');
}

export function getHelenaEmbedAccountId() {
  const raw = Cookies.get('cw_d_session_info');
  if (!raw) return null;

  try {
    const data = JSON.parse(raw);
    if (data.helena_embed_account_id == null || data.helena_embed_account_id === '') {
      return null;
    }
    const accountId = Number(data.helena_embed_account_id);
    return Number.isFinite(accountId) ? accountId : null;
  } catch (error) {
    return null;
  }
}

export function helenaEmbedAllowsRoute(route) {
  const embedAccountId = getHelenaEmbedAccountId();
  if (!embedAccountId) return true;
  if (!isHelenaDashboardRoute(route)) return false;

  return Number(route.params?.accountId) === embedAccountId;
}
